/* Rocos country detection. Native Shopify localization is handled separately. */
(() => {
  'use strict';
  if (window.rocosGeoIPThemeDebug) return;
  const endpoint = 'https://rocos-geoip.cloudflare-bossnet.workers.dev/geo';
  const KEY = 'rocos_geoip_debug_v1';
  const STOP = 'rocos_geoip_debug_stop_v1';
  const TTL = 15 * 60 * 1000;
  let inFlight = null;
  const read = (storage, key) => {
    try { return JSON.parse(window[storage].getItem(key)); } catch { return null; }
  };
  const write = (key, value) => {
    try { window.localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
  };
  function normalize(data) {
    if (!data || data.source !== 'cloudflare' || data.mode !== 'diagnostic_only' ||
        !(data.country === null || (typeof data.country === 'string' && data.country.length === 2 && /^[A-Z]{2}$/.test(data.country) && data.country !== 'XX'))) {
      throw new Error('Răspuns GeoIP invalid.');
    }
    const text = value => typeof value === 'string' && value.length <= 100 ? value : null;
    return {source:'cloudflare', mode:'diagnostic_only', country:data.country,
      country_available:data.country !== null, supported_shop_country:['RO','DE','ES','IT'].includes(data.country),
      continent:text(data.continent), timezone:text(data.timezone), colo:text(data.colo), detected_at:text(data.detected_at)};
  }
  function display(data, cached) {
    if (data.country && !read('localStorage', 'rocos_geoip_initial_country_v1')) {
      write('rocos_geoip_initial_country_v1', {country:data.country, at:Date.now()});
    }
    let config = {};
    try { config = JSON.parse(document.getElementById('rocos-config')?.textContent || '{}'); } catch {}
    console.table({sursa:cached ? 'localStorage (maximum 15 minute)' : 'Cloudflare',
      tara_detectata:data.country || 'necunoscută', continent:data.continent || 'necunoscut',
      fus_orar:data.timezone || 'necunoscut', centru_cloudflare:data.colo || 'necunoscut',
      tara_shopify:config.country || window.Shopify?.country,
      limba_shopify:config.locale || window.Shopify?.locale,
      moneda_shopify:config.currency || window.Shopify?.currency?.active, salvat_local:true});
    console.info('[Rocos GeoIP] Țară detectată. Localizarea magazinului respectă alegerile manuale.');
    return data;
  }
  function blocked() {
    const now = Date.now();
    for (const storage of ['localStorage', 'sessionStorage']) {
      const old = read(storage, STOP);
      if (!old) continue;
      // Old persistent stops become bounded cooldowns under the updated policy.
      const until = Number(old.next_attempt_at) || (Number(old.at) || now) + TTL;
      if (until > now) return true;
      try { window[storage].removeItem(STOP); } catch { return true; }
    }
    return false;
  }
  async function detect() {
    const cached = read('localStorage', KEY);
    const age = Date.now() - cached?.saved_at;
    if (cached?.endpoint === endpoint && age >= 0 && age < TTL) {
      try { return display(normalize(cached.data), true); } catch {}
    }
    if (blocked()) {
      console.warn('[Rocos GeoIP] Pauză temporară după o cerere anterioară.');
      return null;
    }
    if (!write(STOP, {reason:'request_pending', at:Date.now(), next_attempt_at:Date.now()+30000})) return null;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    let retryAt = Date.now() + TTL;
    try {
      const response = await fetch(endpoint, {method:'GET', mode:'cors', credentials:'omit', cache:'no-store',
        redirect:'error', referrerPolicy:'no-referrer', signal:controller.signal});
      if (!response.ok) {
        const raw = response.headers.get('Retry-After');
        if (raw) {
          const seconds = Number(raw);
          const reported = Number.isFinite(seconds) ? Date.now() + seconds*1000 : Date.parse(raw);
          if (Number.isFinite(reported)) retryAt = Math.max(retryAt, reported);
        }
        const error = new Error('HTTP ' + response.status); error.status = response.status; throw error;
      }
      const data = normalize(await response.json());
      if (!write(KEY, {endpoint, saved_at:Date.now(), data})) throw new Error('localStorage indisponibil');
      window.localStorage.removeItem(STOP);
      return display(data, false);
    } catch (error) {
      write(STOP, {reason:'request_failed', status:error.status || null, at:Date.now(), next_attempt_at:retryAt});
      console.warn('[Rocos GeoIP]', error.message, 'Magazinul rămâne disponibil; fără reîncercări repetate pe această pagină.');
      return null;
    } finally { clearTimeout(timer); }
  }
  function run() {
    if (inFlight) return inFlight;
    inFlight = Promise.resolve().then(() => window.navigator?.locks?.request
      ? window.navigator.locks.request('rocos-geoip-debug-v1', detect) : detect())
      .catch(() => null).finally(() => { inFlight = null; });
    return inFlight;
  }
  window.rocosGeoIPThemeDebug = {run};
  window.rocosGeoIPDebug = run;
  // The localization controller starts detection only when needed. Manual console calls stay available.
})();
